import type { Mail, MailDraft } from '../../types/db';

export const mails: Mail[] = [
  {
    id: 'm-bakker-1',
    contactId: 'bakker',
    subject: 'Lukt donderdag?',
    received: 'gisteren 19:40',
    snippet: 'Zullen we donderdag de nieuwe offerte doornemen?',
    needsReply: true,
  },
  {
    id: 'm-lisa-1',
    contactId: 'lisa',
    subject: 'Kennismaking dinsdag?',
    received: '3 dagen geleden',
    snippet: 'Leuk dat je tijd hebt. Zullen we het over het portaal hebben?',
    needsReply: false,
  },
  {
    id: 'm-lisa-2',
    contactId: 'lisa',
    subject: 'Wensenlijst portaal',
    received: 'gisteren',
    snippet: 'In de bijlage onze wensenlijst voor het klantportaal.',
    needsReply: false,
  },
];

export const mailDrafts: MailDraft[] = [
  {
    id: 'd-bakker-reply',
    mailId: 'm-bakker-1',
    to: 'bakker',
    subject: 'Re: Lukt donderdag?',
    body: 'Hoi, donderdag om 10:00 komt goed uit. Ik stuur woensdag de bijgewerkte offerte.',
    where: 'cloud',
  },
  {
    id: 'd-bakker-voice',
    mailId: 'm-bakker-1',
    to: 'bakker',
    subject: 'Re: Lukt donderdag?',
    body: 'Hoi, donderdag komt goed uit. Ik zie je dan om 10:00.',
    where: 'cloud',
  },
];
